import debounce from 'lodash/debounce';
import { AddressVerificationService } from 'services/addressVerification.service';
import { ShipToLocationsService } from 'services/shipToLocations.service';
import { ValidatePostalCode } from 'directives/validatePostalCode';
import { FormatZip } from 'directives/formatZip';
import { GoogleAutoComplete } from 'components/googleAutocomplete/googleAutocomplete';
import { InputContainer } from 'components/inputContainer/inputContainer';
import {
    AUTOCOMPLETE_COUNTRIES,
    ADMINISTRATIVE_AREA_LEVEL_1_LABELS,
    DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL
} from 'app/constants';
import {
    getStatesFromShipToLocationCountry
} from 'services/addressUtils';
import { countries } from '@material-dev/country-data';

import template from './addressForm.html';
import './addressForm.scss';

export const AddressForm = angular
    .module('checkout.components.addressForm', [
        AddressVerificationService,
        ShipToLocationsService,
        ValidatePostalCode,
        FormatZip,
        GoogleAutoComplete,
        InputContainer
    ]).component('addressForm', {
        template,
        bindings: {
            model: '=',
            autoCompletePrefix: '@',
            showCardholderNameInput: '<',
            shouldVerifyAddress: '<',
            verifiedMessage: '<'
        },
        controller: class AddressFormCtrl {
            constructor(
                $scope,
                $timeout,
                addressVerificationService,
                shipToLocationsService
            ) {
                angular.extend(this, {
                    $scope,
                    $timeout,
                    addressVerificationService,
                    shipToLocationsService,
                    AUTOCOMPLETE_COUNTRIES,
                    ADMINISTRATIVE_AREA_LEVEL_1_LABELS,
                    DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL,
                    countries,
                    isAddressVerified: false
                });
            }

            $onInit() {
                this.shipToLocationsService.get().then((response) => {
                    this.shipToLocations = response.map(location => ({
                        ...location,
                        name: countries[location.country].name
                    }));

                    this.states = getStatesFromShipToLocationCountry(
                        this.shipToLocations, this.model && this.model.country ? this.model.country : 'US'
                    );
                });
                this._autoCompletePrefix = this.autoCompletePrefix ? `${this.autoCompletePrefix} ` : '';
                if (this.model) {
                    this.setAddressFormInputAndLabels(this.model.country);
                }

                const verifyAddress = debounce(this.verifyAddress.bind(this), 500);

                if (this.shouldVerifyAddress) {
                    ['address1', 'address2', 'city', 'state', 'zip'].forEach((formElement) => {
                        this.$scope.$watch(`$ctrl.model.${formElement}`, (newValue, oldValue) => {
                            if (newValue !== oldValue) {
                                verifyAddress();
                            }
                        });
                    });
                }

                this.searchText = this.model.address1;
            }

            verifyAddress() {
                this.addressVerificationService.isAddressVerified(this.model)
                    .then(status => this.isAddressVerified = status);
            }

            onCountryChange() {
                this.setAddressFormInputAndLabels(this.model.country);
                this.states = getStatesFromShipToLocationCountry(this.shipToLocations, this.model.country);
            }

            setAddressFormInputAndLabels(country) {
                this.domesticAddress = country === 'US';
            }

            onAddressChange() {
                if (this.selectedAddress && this.selectedAddress.placeId) {
                    this.addressVerificationService
                        .getAutocompleteAddressParts(this.selectedAddress.placeId)
                        .then(address => this.setAutocompleteAddressToModel(address));
                } else {
                    this.model.address1 = this.selectedAddress;
                }
            }

            onSearchTextChange() {
                this.model.address1 = this.searchText;
            }

            searchAddress(searchText) {
                return this.addressVerificationService.autocompleteAddress(
                    searchText,
                    this.model.country
                );
            }

            setAutocompleteAddressToModel(addressFromAutocomplete) {
                this.selectedAddress = addressFromAutocomplete.address1;
                this.model.address1 = addressFromAutocomplete.address1;
                this.model.address2 = addressFromAutocomplete.address2;
                this.model.city = addressFromAutocomplete.locality;
                this.model.state = addressFromAutocomplete.administrativeArea;
                this.model.postalCode = addressFromAutocomplete.postalCode;
                this.model.country = addressFromAutocomplete.country;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/addressForm/addressForm.js